import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useKeycloak } from '@react-keycloak/web';

type ProtectRouteProps = {
  onNotAuthenticatedRedirectURL: string;
};

export default function ProtectRoute({ onNotAuthenticatedRedirectURL }: ProtectRouteProps): JSX.Element {
  const { keycloak } = useKeycloak();
  return (keycloak.authenticated ? <Outlet /> : <Navigate to={onNotAuthenticatedRedirectURL} />);
}
